var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      {
        name: 'Support Warranty Policy',
        to: {
          name: 'SupportWarrantyPolicy'
        }
      },
      {
        name: 'Edit',
        to: {
          name: 'SupportWarrantyPolicyEdit',
          params: {
            id: _vm.$route.params.id
          }
        }
      } ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("編輯Support Warranty Policy")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_c('span',[_vm._v("取消")])]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveHandler}},[_c('span',[_vm._v("儲存")])])],1),_c('SupportWarrantyPolicyCreateEdit'),_c('LangDialog',{attrs:{"isOpen":_vm.isLangOpen},on:{"update:isOpen":function($event){_vm.isLangOpen=$event},"update:is-open":function($event){_vm.isLangOpen=$event},"confirm-submit":function($event){return _vm.saveHandler()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }